export const DEFAULT_EVENT_COLORS = {
    background: '#290401',
    primary: '#EAD9CB',
    secondary: '#F9C49A',
};

export const parseEventColors = (value) => {
    try {
        const parsed = typeof value === 'string' ? JSON.parse(value) : value;
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
            return DEFAULT_EVENT_COLORS;
        }

        return { ...DEFAULT_EVENT_COLORS, ...parsed };
    } catch {
        return DEFAULT_EVENT_COLORS;
    }
};

